import { render, staticRenderFns } from "./form-team.vue?vue&type=template&id=4c8377ef&scoped=true"
import script from "./form-team.vue?vue&type=script&lang=js"
export * from "./form-team.vue?vue&type=script&lang=js"
import style0 from "./form-team.vue?vue&type=style&index=0&id=4c8377ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8377ef",
  null
  
)

export default component.exports